import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7198c046"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "viewModal",
  tabindex: "-1",
  "aria-labelledby": "viewModal",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title fw-bold text-center w-100" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_7 = { class: "py-4 border-bottom" }
const _hoisted_8 = { class: "text-center fs-7" }
const _hoisted_9 = { class: "text-center fs-7" }
const _hoisted_10 = { class: "overflow-auto text-scroll fs-7 terms p-4 mx-5 my-5 text-break break-spaces" }
const _hoisted_11 = { class: "d-flex justify-content-center modal-footer" }

import { translate } from '@/languages/i18n'
import Button from '@/components/button/index.vue'
import { ReplayName } from '@/constants/common.ts'
import { ConvertFromLocalTime } from '@/constants/datepicker.ts'


export default /*#__PURE__*/_defineComponent({
  props: {
  historyData: {
    type: Object,
    default: () => ({
      id: '',
      date: '',
      content: '',
    }),
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('CD40titleView')), 1),
          _hoisted_6
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(translate)('CD40author')) + _toDisplayString(__props.historyData?.created_employee_user?.admin_community_management_id !== null
                  ? _unref(ReplayName)(
                      __props.historyData?.created_employee_user?.is_deleted_in_30_days,
                      __props.historyData?.created_employee_user?.available,
                      __props.historyData?.created_employee_user?.family_name,
                      __props.historyData?.created_employee_user?.given_name,
                      1
                    )
                  : ''), 1),
            _createElementVNode("div", _hoisted_9, "Ver. " + _toDisplayString(__props.historyData?.version) + " " + _toDisplayString(_unref(translate)('CDUpdateDate') + ' : ') + " " + _toDisplayString(_unref(ConvertFromLocalTime)(__props.historyData?.created_at)), 1)
          ]),
          _createElementVNode("div", _hoisted_10, _toDisplayString(__props.historyData?.content), 1)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(Button, {
            title: _unref(translate)('close'),
            type: 'secondary',
            className: 'fw-bold',
            dataBsToggle: 'modal'
          }, null, 8, ["title"])
        ])
      ])
    ])
  ]))
}
}

})